import { createAction } from '@reduxjs/toolkit'

export const setProfileData = createAction('SET_PROFILE_DATA');